import React from 'react';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import moment from 'moment';
import { DatePicker, DatePickerInput } from 'carbon-components-react';
import { store } from '../../../store';

class CustomDatePicker extends React.Component {
  constructor (props) {
    super(props);

    let today = new Date();
    const endDate = today.toLocaleDateString('es-ES');

    if (store.getState().configFile.startDateShow) {
      console.log(store.getState().configFile.startDateShow);
      today = new Date(store.getState().configFile.startDateShow);
    } else {
      const daysToShow = store.getState().configFile.daysToShow ? parseInt(store.getState().configFile.daysToShow) : 7;
      const setDay = today.getDate() - daysToShow;
      today.setDate(setDay);
    }

    const startDate = today.toLocaleDateString('es-ES');

    this.state = {
      formData: props.formData,
      startDate,
      endDate
    };
  }

  async handleDateChange (from, to) {
    this.setState(
      {
        endDate: moment(to).format('DD/MM/YYYY'),
        startDate: moment(from).format('DD/MM/YYYY')
      },
      () => {
        this.props.onChange({
          newDates: {
            from,
            to
          }
        });
      }
    );
  }

  render () {
    return (
      <DatePicker
        id='date-picker'
        datePickerType='range'
        dateFormat='d/m/Y'
        locale='es'
        maxDate={moment(new Date()).format('DD/MM/YYYY')}
        onChange={async event => {
          this.handleDateChange(event[0], event[1]);
        }}
      >
        <DatePickerInput
          id='date-picker-input-id-start'
          type='text'
          labelText={funcTranslateHelper('CustomDatePicker.Desde')}
          value={this.state.startDate}
        />

        <DatePickerInput
          id='date-picker-input-id-end'
          type='text'
          labelText={funcTranslateHelper('CustomDatePicker.Hasta')}
          value={this.state.endDate}
        />
      </DatePicker>
    );
  }
}

export default CustomDatePicker;
